import { observable, action } from 'mobx';

export default class RepairData {
    @observable repairData = {}; // 地磁维修更换数据

    @action setRepairData(data) {
      this.repairData = { ...data }; // 记录地磁维修更换数据
    }
}

export const repairData = new RepairData();
